export default __webpack_public_path__ + "static/media/suvinil-logo.527f9f5d.png";